import React, { useEffect, useState } from 'react';
import { Button, Col, Form, Modal, Row, Spinner } from 'react-bootstrap';
import { API_BASE_URL, countries, getBearerToken, handleMouseWheel } from '../../functions';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import ToastMessage from '../ToastMessage';
import { useAuth } from '../pages/auth/AuthProvider';
import banner from "../../images/poster3.jpg";
import toast from 'react-hot-toast';
import ImageCarousel from '../common-Components/ImageCarousel';


const Banner = ({ show, setShow, path = '' }) => {
    // const handleClose = () => setShow(false);
    const [toastMessage, setToastMessage] = useState(null);
    const [loading, setLoading] = useState(false);
    const { token } = useAuth()
    const [data, setData] = useState(
        {
            agentid: token.agent_id,
            w_number: '',
            code: ''
        }
    );
    const [passwordType, setPasswordType] = useState(true);
    const [showChnage, sethowChnage] = useState(false)
    const [error, setError] = useState('');
    const [codeSent, setCodeSent] = useState(false);
    const { updateTokenVAlue } = useAuth();
    const Navigate = useNavigate();
    const [visible, setVisible] = useState(false);
    const [apiData, setApiData] = useState("");
    const [showDoNotShowAgain, setShowDoNotShowAgain] = useState(false);

    useEffect(() => {
        axios.get(`${API_BASE_URL}/allbanners-list?page=1}`, {
            headers: {
                'Authorization': `Bearer ${getBearerToken()}`
            }
        }).then(response => {
            setApiData(response?.data?.data?.data);
        }).catch(error => {
            // Handle errors
        });
    }, [])

    useEffect(() => {
        const doNotShowAgain = localStorage.getItem('hidePopupPermanently');
        const lastClosed = localStorage.getItem('popupClosedAt');
        const now = new Date().getTime();
        const oneHour = 60 * 60 * 1000; // 1 hour in ms

        if (!doNotShowAgain && (!lastClosed || now - lastClosed > oneHour)) {
            setVisible(true);

            // Show "Do not show again" button after 6 seconds
            setTimeout(() => {
                setShowDoNotShowAgain(true);
            }, 6000);
        }
    }, []);


    const handleClose = () => {
        const now = new Date().getTime();
        localStorage.setItem('popupClosedAt', now);
        setVisible(false);
    };


    const handleDoNotShowAgain = () => {
        localStorage.setItem('hidePopupPermanently', 'true');
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <>
            {toastMessage && <ToastMessage type={toastMessage.type} message={toastMessage.message} show={toastMessage.show} />}
            <Modal show={show} size='md' onHide={handleClose} aria-labelledby="contained-modal-title-vcenter" centered backdrop="static" keyboard={false}>
                {/* <Modal.Header closeButton className="d-flex px-4 align-items-center">
                    <Modal.Title id="contained-modal-title-vcenter" className='redtext'>Important Notification</Modal.Title>
                </Modal.Header> */}
                <Modal.Body className="px-4">
                    <ImageCarousel data={apiData}/>
                    {/* <p>Click on this image to check out our second portal!</p>
                    <div className="">
                        <Link target='_blank' to={'https://faizantravels.pk'} className={'d-block w-100'}><img className={'rounded img-fluid'} src={banner} alt={'icon'} /></Link>
                    </div> */}
                </Modal.Body>
                <Modal.Footer className="">
                    {/* {showDoNotShowAgain &&
                        <Button variant="" className="w-100px F1F1F1bg fontsize14 fontweight700 me-3" onClick={handleDoNotShowAgain}>Do not show again</Button>
                    } */}
                    <Button variant="" type='submit' className="w-100px text-white fontweight700 fontsize14 redbg" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default Banner;